<template lang="pug">
  div
    // NOT PTS BUTTON
    Button3d.btn-xlarge.pd(
      v-if="displayPts.length < 1 && !recordingKind && !recording",
      :block="true",
      :size="omitirPausa ? 'x-tall' : 'large'",
      :color="displayInfo.color",
      @click.prevent="marcarPonto",
      :id="id")
        .pts-wrapper
          p.kind-number(aria-hidden="true") {{ displayInfo.number }}
          p.kind-name {{ displayInfo.kindName }}
          img.pts-icon.re-mobile(:src="displayInfo.icon", :class="{[displayInfo.iconClass]: true}", aria-hidden="true")

    // HAS PTS BUTTON
    Button3d.btn-xlarge.pd(
      v-if="displayPts.length >= 1 && !recordingKind && !recording",
      :active="true",
      @click.prevent="marcarPonto", color="default", :block="true",
      :size="omitirPausa ? 'x-tall' : 'large'",
      :id="id")
          .pts-container
            div.pontos-exibidos
              | {{ displayInfo.kindName }} {{displayInfo.text}} ({{ displayInfo.number }})
              h4.is-size-5(
                v-for="ponto in pontosParaExibicao"
              ) {{ `${ponto.dia} ${ponto.hora}${ponto.origem}` }}

    Button3d.btn-xlarge.pd(
    v-if="!recordingKind && recording",
    color="default", :block="true",
    :size="omitirPausa ? 'x-tall' : 'large'",
    )
      .pts-wrapper
        p.kind-number {{ displayInfo.number }}
        p.kind-name {{ displayInfo.kindName }}
        img.pts-icon.re-mobile(:src="displayInfo.icon", :class="{[displayInfo.iconClass]: true}")

    // RECONDING AUDIO BUTTON
    Button3d.btn-xlarge.pd(
      v-if="recordingKind",
      :color="displayInfo.color",
      size="large",
      :block="true")
          slot
            p {{ $t('componentes.marcacao.componentes.ptButton.botaoDeGravacao') }}...
            p {{seconds}}

</template>

<script>
import { mapGetters } from 'vuex'
import { formataStringParaCaptalize } from '../../../utils'
import { pegarListaDePontosDoDia } from './PtButton.script'

export default {
  props: {
    displayPts: {type: Array, required: true},
    kind: {type: String, required: true},
    recording: {type: Boolean, required: true},
    recordingKind: {type: Boolean, required: true},
    seconds: {type: Number, required: true},
    id: {type: String},
    omitirPausa: {type: Boolean, default: false}
  },
  computed: {
    ...mapGetters(['visual']),
    displayInfo () {
      const i = this.omitirPausa ? {
        'ENTRADA': [this.visual.webButtonEntrada || 'success', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.tipoEntrada'), 1, require('../../../../static/images/entrada.svg'), 'entrada', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.textoEfetuada')],
        'SAÍDA': [this.visual.webButtonSaida || 'danger', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.tipoSaida'), 4, require('../../../../static/images/saida.svg'), 'saida', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.textoEfetuada')]
      } : {
        'ENTRADA': [this.visual.webButtonEntrada || 'success', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.tipoEntrada'), 1, require('../../../../static/images/entrada.svg'), 'entrada', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.textoEfetuada')],
        'PAUSA': [this.visual.webButtonPausa || 'info', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.tipoPausa'), 2, require('../../../../static/images/pausa.svg'), 'pausa', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.textoEfetuada')],
        'RETORNO PAUSA': [this.visual.webButtonRetorno || 'warning', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.tipoRetorno'), 3, require('../../../../static/images/retorno.svg'), 'retorno', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.textoEfetuado')],
        'SAÍDA': [this.visual.webButtonSaida || 'danger', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.tipoSaida'), 4, require('../../../../static/images/saida.svg'), 'saida', this.$t('componentes.marcacao.componentes.ptButton.displayInfo.textoEfetuada')]
      }
      return {
        color: i[this.kind][0],
        kindName: i[this.kind][1],
        number: i[this.kind][2],
        icon: i[this.kind][3],
        iconClass: i[this.kind][4],
        text: i[this.kind][5]
      }
    },
    pontosParaExibicao () {
      return pegarListaDePontosDoDia(this.displayPts)
    }
  },
  methods: {
    marcarPonto () {
      this.$emit('marcarPonto', formataStringParaCaptalize(this.kind))
    }
  }
}
</script>

<style scoped>
.pontos-exibidos {
  text-align: left;
}

.pts-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1rem;
}
.btn-xlarge {
  width: 370px;
  height: 185px;
  padding: 0px;
  font-size: 25px !important;
  line-height: normal;
  margin: 0px;
  grid-template-rows: 2fr 2fr;
}

@media screen and (min-width: 1024px) and (max-height: 600px) {
  .btn-xlarge {
    height: 130px;
  }
}

@media screen and (max-width: 1000px) {
  .btn-xlarge {
    height: 130px;
  }
}

@media screen and (max-width: 420px) {
  .btn-xlarge {
    width: 350px;
  }
}
img.re-mobile {
  float: right;
  max-width: 100px;
}
.pts-wrapper{
  position: relative;
  height: 100%;
  flex-direction: column;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 60px 1fr;
}
.pts-n{
  position: absolute;
  left: 30px;
  top: 0px;
  font-size: 60px;
}
.pts-text{
  position: absolute;
  bottom: 10px;
  left: 30px;
  font-size: 35px;
}
.pts-icon{
  position: absolute;
  bottom: 10px;
  right: 30px;
}

.entrada, .saida {
  max-height: 80px;
}
.pausa {
  max-height: 110px;
}
.retorno {
  max-height: 75px;
}
.kind-name, .kind-number {
  text-align: left;
}
.kind-name {
  grid-row-start: 2;
  grid-column-start: 1;
}

@media (min-width: 1000px) {
  .pts-wrapper{
    grid-template-rows: 80px 1fr;
    gap: 1rem;
  }
  .kind-number, .kind-name {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .kind-number {
    padding-left: 2vw;
    font-size: 8vh;
  }
  .kind-name {
    padding-left: 2vw;
    font-size: 5vh;
  }
}

@media (min-width: 1000px) and (max-height: 600px) {
  .pts-wrapper{
    grid-template-rows: 60px 1fr;
  }
}

@media (min-width: 1000px) and (max-width: 1280px) {
  .kind-name {
    padding-left: 2vw;
    font-size: 4.5vh
  }

  .pts-icon {
    width: 30%;
  }
}

@media (min-width: 600px) and (max-width: 1000px) {
  .kind-number, .kind-name {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .kind-number {
    padding-left: 2vw;
    font-size: 6vh;
  }
  .kind-name {
    padding-left: 2vw;
    font-size: 5vh;
  }
}
@media (max-width: 600px) {
  .kind-number, .kind-name {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .kind-number {
    padding-left: 2vw;
    font-size: 6vh;
  }
  .kind-name {
    padding-left: 2vw;
    font-size: 5vh;
  }
}
</style>
